import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import {MdClose} from 'react-icons/md'
import { Fade, IconButton, Backdrop, ThemeProvider, createTheme, Tabs, Tab } from '@mui/material';
import YouTube from 'react-youtube';
import VideoEmbed from './VideoEmbed';
import { useState } from 'react';
import PropTypes from 'prop-types';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "fit-content",
    bgcolor: "background.paper",
    border: "2px solid #FFFFFF",
    boxShadow: 24,
    borderRadius: 2,
    outline: "none"
};

const theme = createTheme({
  typography: {
    fontFamily:  'SoraMedium' 
  },
});

export default function VideoModal({open, handleOpen, handleClose,videoData}) {

    const [tabValue, setTabValue] = useState(0);

    const handleChange = (event, newValue) => {
      setTabValue(newValue);
    };

    const opts = {
        height: '500',
        width: '820',
        playerVars: {
        //   https://developers.google.com/youtube/player_parameters
          autoplay: 1,
          rel:0
        },
      };
  
      const muteVideo = (event) =>{
        event.target.playVideo();
      }

    const playPause = (event) =>{
        event.target.playVideo();
        event.target.unloadModule("captions");
        // event.target.mute();
      }

  return (
    <ThemeProvider theme={theme}>
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
        <Box sx={style} className="p-md-4 p-2 ">
            <div className='w-100 d-flex justify-content-between align-items-center pb-3 border-bottom'>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {videoData?.text}
          </Typography>
          <div>
          <IconButton size='small' onClick={handleClose}>
          <MdClose/>
          </IconButton>
          </div>
          </div>
          {videoData?.isMultiple ? 

          
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={tabValue} onChange={handleChange} aria-label="Server Access MFA">
                {videoData?.videos?.map((video, index)=> {
                  return(
                    <Tab label={video?.videoTitle} {...a11yProps(index)} className='text-capitalize'/>
                  )
                })}
              </Tabs>
            </Box>
            {videoData?.videos?.map((video, index)=> {
                  return(
                    <CustomTabPanel value={tabValue} index={index}>
                       {videoData?.videoType == "drive" 
                        ?
                        <VideoEmbed videoId={video?.videoId} />
                        :
                        <YouTube videoId={video?.videoId} opts={opts} onReady={playPause}/>
                      }
                    </CustomTabPanel>
                  )
                })}
          </Box>

          :

          videoData?.videoType == "drive" 
          ?
          <VideoEmbed videoId={videoData?.videoId} />
          :
          <YouTube videoId={videoData?.videoId} opts={opts} onReady={playPause}/>
          
        }
          
        </Box>
        </Fade>
      </Modal>
    </div>
    </ThemeProvider>
  );
}